<template>
  <div class="card red">
    <div class="content">
      <div class="header">
        {{ $t('MAIL_SERVICE_TRIGGER') }}
        <i class="right floated mail icon"></i>
      </div>
      <div class="meta">
        {{ $t('MAIL_SERVICE_TRIGGER_META') }}
      </div>
    </div>

    <div class="primary content">
      <div class="field">
        <typeahead
          :max-items="100"
          :current-item="service.name"
          :items="allMailServices"
          :label-text="$tc('MAIL_SERVICE', 1)"
          :placeholder-text="$tc('MAIL_SERVICE', 1)"
          :empty-text="$t('NO_ITEMS_MATCH', { things: $tc('MAIL_SERVICE', 2) })"
          :select-handler="setService"
        >
          <template slot="dropdown" slot-scope="props">
            {{ $t(props.item.name) }}
          </template>
        </typeahead>
      </div>
      <regex-field v-model="trigger.configuration.fromAddress" :labelText="$t('FROM_ADDRESS')" />
      <regex-field v-model="trigger.configuration.toAddress" :labelText="$t('TO_ADDRESS')" />
      <regex-field v-model="trigger.configuration.ccAddress" :labelText="$t('CC_ADDRESS')" />
      <regex-field v-model="trigger.configuration.subject" :labelText="$t('MAIL_SUBJECT')" />
      <regex-field v-model="trigger.configuration.body" :labelText="$t('MAIL_BODY')" />
      <regex-field v-model="trigger.configuration.attachments" :labelText="$t('ATTACHMENTS')" />
    </div>

    <slot name="footer"></slot>
  </div>
</template>

<script>
// @flow
import _ from 'lodash'
import { Typeahead, RegexField } from 'ui'
import { Service, Typenames } from 'services'
import { map } from 'rxjs/operators'
import { ActionTypes } from 'store'
export default {
  name: 'mailservicetrigger',
  components: {
    Typeahead,
    RegexField
  },
  props: {
    trigger: {
      type: Object,
      default: () => {
        return {
          configuration: {
            serviceId: '',
            fromAddress: '',
            toAddress: '',
            ccAddress: '',
            subject: '',
            body: '',
            attachments: ''
          }
        }
      }
    }
  },

  data() {
    return {
      service: {}
    }
  },

  computed: {
    allServices() {
      return this.$store.state.service.items
    },
    allMailServices() {
      return _.map(_.filter(this.allServices, s => s.serviceType === 'MAIL'), s => {
        return { name: s.name || s.id, key: s.id, id: s.id, value: s.id }
      })
    }
  },

  methods: {
    setService(s) {
      this.trigger.configuration.serviceId = s.id
    }
  },

  created() {
    Service.readAllServices()
  },

  mounted() {
    if (_.isEmpty(this.service))
      this.service =
        _.find(this.allServices, s => s.id === this.trigger.configuration.serviceId) || {}
  },

  watch: {
    allServices() {
      if (_.isEmpty(this.service))
        this.service =
          _.find(this.allServices, s => s.id === this.trigger.configuration.serviceId) || {}
    }
  }
}
</script>
